//const HOST_NAME = 'http://localhost:8886';
const HOST_NAME = 'https://ghp.stoelting-michael.de';

export default {
    HOST_NAME
}